module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAZAAAAGQBeJH1SwAAAB90RVh0U29mdHdhcmUATWFjcm9tZWRpYSBGaXJld29ya3MgOLVo0ngAAADaSURBVEiJrdaxCQJBEIXhXxGrEEwE04kNFBNDM6uwAk3ERGuwBjMbMDOeAgQRrMLkjITj3NnbdWeiZRjexyzcsZ2qqmiWiMyAE/AE1qp6/xlKrK7R3wJjYAFcRWTkDdxq50EJYgFH4OKBBAFVfQMrD8TawA0xAS8kCnggrUApkgSUIJ3QlxwrEekDZ2BZa7+Aqao+mvPJG3wrssk+NJ8N5FY2ELmiXTEQCZ+H7j8LaAk3f+dJwL/hSUBJeCtQGh4FPMJNwCvcBICNR3gMmHiEA/SM/gEY4vBs+QDIV37F4GX4LAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/menu-right-dark.png
// module id = guj3
// module chunks = 1